import React from 'react';
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from "@mui/icons-material/Delete";


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

const AdmissionFormTableView = props => {
    const classes = useStyles();
    const { rows = [], columns = [], onRemove = fn => fn } = props;

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {columns.map((column, i) => (
                            <TableCell key={i}>{column.label}</TableCell>
                        ))}
                        <TableCell align="right">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow key={index}>
                            {columns.map((column) => (
                                <TableCell key={column.key} component="th" scope="row">
                                    {row[column.key]}
                                </TableCell>
                            ))}
                            <TableCell align="right"> <IconButton onClick={(e, i = index) => onRemove(e,i)} size="large">
                                <DeleteIcon fontSize="small" />
                            </IconButton></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {rows.length <= 0 && <Paper style={{
                display: 'flex',
                justifyContent: 'center',
                padding: 50
            }}>No Data</Paper>}
        </TableContainer >
    );
}

AdmissionFormTableView.propTypes = {
    rows: PropTypes.array,
    onRemove: PropTypes.func,
    columns: PropTypes.array
};

export default AdmissionFormTableView;